<template>
  <div>
    <b-form class="d-flex align-items-center flex-column" @submit="onSubmit">
      <b-form-group>
        <b-form-radio-group id="radio-group-2" class="text-center">
          <label class="icon-wrapper">
            <div class="overlay" />
            <img
              src="/images/course/voto-pessimo.svg"
              class="img-fluid w-100"
              v-bind:class="{ 'img-ring': this.grade && this.grade == -1 }"
              v-b-tooltip.hover
              :title="trans('courses.do_not_think_so')"
            />
            <b-form-radio
              type="radio"
              name="grade"
              value="-1"
              id="rateOption1"
              class="radio"
              v-model="grade"
            />
          </label>
          <label class="icon-wrapper">
            <div class="overlay" />
            <img
              src="/images/course/voto-abbastanza.svg"
              class="img-fluid w-100"
              v-bind:class="{ 'img-ring': this.grade && this.grade == 0 }"
              v-b-tooltip.hover
              :title="trans('courses.could_not_say')"
            />
            <b-form-radio
              type="radio"
              name="grade"
              value="0"
              id="rateOption2"
              class="radio"
              v-model="grade"
            />
          </label>
          <label class="icon-wrapper">
            <div class="overlay" />
            <img
              src="/images/course/voto-ottimo.svg"
              class="img-fluid w-100"
              v-bind:class="{ 'img-ring': this.grade && this.grade == 1 }"
              v-b-tooltip.hover
              :title="trans('courses.think_so')"
            />
            <b-form-radio
              type="radio"
              name="grade"
              value="1"
              id="rateOption3"
              class="radio"
              v-model="grade"
            />
          </label>
        </b-form-radio-group>
      </b-form-group>
      <div class="row pl-0 pl-sm-5 w-100">
        <div class="col-12 mt-4 pl-3 pr-0 border-left">
          <h6 class="mb-4">{{ feedbackLabel }}</h6>
          <textarea
            id="feedbackCompletedModule"
            class="form-control"
            name="feedback"
            rows="3"
            v-model="feedback"
          />
        </div>
      </div>
      <div class="align-self-end mt-5">
        <div>
          <b-button
            v-if="skipButton"
            variant="link"
            class="mr-3"
            @click="$emit('skipEval')"
            :disabled="loading"
            >{{ skipButton }}</b-button
          >
          <b-spinner small type="grow" v-if="loading" />
          <b-button type="submit" variant="secondary" :disabled="grade === '' || loading">
            {{ trans("courses.send_feedback") }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "EvaluationForm",
  props: {
    loading: Boolean,
    gradeVal: String,
    feedbackVal: String,
    feedbackLabel: String,
    skipButton: String,
  },
  data() {
    return {
      grade: this.gradeVal,
      feedback: this.feedbackVal,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("submitEval", this.grade, this.feedback);
    },
  },
  mounted() {
    this.grade = this.gradeVal;
    this.feedback = this.feedbackVal;
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-control-inline {
  visibility: hidden;
}

.icon-wrapper {
  margin: 0;
  width: 80px;
  position: relative;

  @media (min-width: 768px) {
    margin: 0 20px;
    width: 105px;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 105px;
    height: 100%;
    display: block;
  }
}

.img-fluid {
  cursor: pointer;
  border-radius: 100% !important;
  border: 5px solid $color-white;
}

img:not(.img-ring):hover {
  border-color: #ffb292;
}

.img-ring {
  border-color: $color-orange;
}

.tooltip {
  top: 0;
}
</style>
